import { useRef } from "react";
import { useForm } from "react-hook-form";
import { IFiltroAtendimentosVistorias } from "../../../../Interfaces/VistoriaEntregaChaves/ListarAtendimentosVistorias/ListarAtendimentosVistoriasInterfaces";
import { ListarEtapasEntregaDeChavesController } from "../../../../Controllers/Geral/Etapas/EtapasControllers";
import { ListarCanalAtendimentoContoller } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoCanalAtendimento/TipoCanalAtendimentoController";
import { ListarTipoPesoAtendimentoController } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoPesoAtendimento/TipoPesoAtedimentoControllers";
import {
    ListarEmpreendimentosPesquisaController,
    ListarProdutosPorEmpreendimentosController,
} from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { useModuloInfo } from "../../../../Context/ModuloInfo";

const filtroInicial: any = {
    DT_INICIAL_IN: "",
    DT_INICIAL_FN: "",
    DT_FINAL_IN: "",
    DT_FINAL_FN: "",
    DS_STATUS_CASO: "Aberto",
    ID_UNIDADE: 0,
    ID_EMPREENDIMENTO: [],
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: [],
    ID_CASO: "",
    ID_CONTA: 0,
    ID_USUARIO: 0,
    DS_NOME_CONTA: "",
    DS_NOME_CONTATO: "",
    ID_CATEGORIA_ATENDIMENTO: [],
    ID_SUBCATEGORIA: 0,
    ID_ACOMPANHAMENTO: 0,
    FL_ANDAMENTO: 2,
    FL_CONTEM: false,
    PESQUISA: "",
    ID_TIPO_CANAL_ATENDIMENTO: 0,
    ID_TIPOS_PESOS_ATENDIMENTOS: [],
};

export default function useFiltroAtendimentoVistoria(
    handleSubmit: (filter: IFiltroAtendimentosVistorias) => void,
    defaultFilter?: IFiltroAtendimentosVistorias | undefined
) {
    const filter = defaultFilter;
    const FormMethods = useForm();
    const { reset, control } = FormMethods;
    const handleCriarFiltros = handleSubmit;
    const { id } = useModuloInfo();

    const selectInputRef = useRef<any>();
    const selectEmpRef = useRef<any>();
    const etapaRef = useRef<any>();
    const tipoRef = useRef<any>();

    const limparFiltros = () => {
        selectInputRef.current?.clearValue();
        selectEmpRef.current?.clearValue();
        etapaRef.current?.clearValue();
        tipoRef.current?.clearValue();
    };
    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    const { value: lstEtapas } = useAsyncEffect(
        () => ListarEtapasEntregaDeChavesController(),
        []
    );

    const { execute: listarCanalAtendimento } = useAsyncCallback(
        () => ListarCanalAtendimentoContoller(),
        []
    );

    const etapasOptions = lstEtapas?.map((e) => ({
        label: e.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
        value: e.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
    }));

    const { value: listarEmpreendimentos } = useAsyncEffect(
        () => ListarEmpreendimentosPesquisaController(""),
        []
    );

    const lstEmpreendimentosOptions = listarEmpreendimentos?.map((e) => ({
        label: e.DS_EMPREENDIMENTO,
        value: e.ID_EMPREENDIMENTO,
    }));

    const { value: lstTipoPeso } = useAsyncEffect(async () => {
        if (id) return ListarTipoPesoAtendimentoController(id);
    });

    const lstTipoPesoOptions = lstTipoPeso?.map((tipo) => ({
        label: tipo.DS_TIPO_PESO_ATENDIMENTO,
        value: tipo.ID_TIPO_PESO_ATENDIMENTO,
    }));

    const { execute: listarUnidades, value: unidadesListadas } =
        useAsyncCallback(ListarProdutosPorEmpreendimentosController);

    const lstUnidadesOptions = unidadesListadas?.map((e) => ({
        label: e.DS_PRODUTO,
        value: e.ID_PRODUTO,
    }));

    return {
        filter,
        FormMethods,
        reset,
        control,
        handleCriarFiltros,
        selectInputRef,
        selectEmpRef,
        etapaRef,
        tipoRef,
        limparFiltros,
        customStyles,
        lstEtapas,
        listarCanalAtendimento,
        etapasOptions,
        listarEmpreendimentos,
        lstEmpreendimentosOptions,
        lstTipoPeso,
        lstTipoPesoOptions,
        filtroInicial,
        listarUnidades,
        lstUnidadesOptions,
    };
}
